(function() {
  var hardcodedColors = {
    'Rusty_Pink': '#c49893', 'Light_Beige': '#e0d7bf', 'Rust': '#615856',
    'Yellow_Grey': '#8f8b66', 'Ice_Blue': '#7ea8c3', 'Beige_Gold': '#eee8aa',
    'Antique': '#d4937d', 'Bone': '#e5d4c2', 'Chestnut': '#9d443e',
    'Eggshell': '#f1ead7', 'PineTree': '#2c2f1e', 'Gadien': '#d9bf7a',
    'Grullo': '#a19d80', 'Black': '#000000', 'Beige': '#ede8d0',
    'Brown': '#7a4f3f', 'Burgandy': '#943e49', 'cream': '#fdfbd4',
    'Cream': '#fdfbd4', 'chocolate': '#411900', 'Chocolate': '#411900',
    'Silver': '#c4c4c4', 'Lilac': '#e6d7ff', 'maroon': '#550000',
    'Maroon': '#550000', 'Navy': '#000080', 'Navy_Blue': '#000080',
    'offwhite': '#f4eff1', 'Offwhite': '#f4eff1', 'Off_White': '#f2f0ef',
    'fuschia': '#ff00ff', 'Fuschia': '#ff00ff', 'Fuchsia': '#d9027d',
    'White': '#ffffff', 'forest green': '#228b22', 'forest_green': '#1a6c35',
    'Forest_Green': '#228b22', 'peach': '#ffd3ac', 'Peach': '#ffd3ac',
    'royal_blue': '#02066f', 'Royal_Blue': '#02066f', 'wash_green': '#8f8c76',
    'Wash_Green': '#8f8c76', 'Washed_Green': '#b2c7ad', 'Grey_Gold': '#c1b391',
    'Dark_purple': '#a90fa0', 'Dark_Purple': '#a90fa0', 'Dark_purple2': '#612145',
    'Dark_Green': '#06402b', 'light_blue': '#90d5ff', 'Light_Blue': '#90d5ff',
    'ivory': '#e1dcaf', 'Ivory': '#ffffe3', 'light_pink': '#f5dadf',
    'Light_Pink': '#f5dadf', 'powder_pink': '#ffb2d0', 'Powder_Pink': '#ffb2d0',
    'Gold': '#b07f33', 'silver_blue': '#c4d4e0', 'Silver_Blue': '#c4d4e0',
    'Blue_grey': '#d2cff1', 'Blue_Grey': '#6a89a7', 'green_black': '#163812',
    'Green_Black': '#163812', 'powder_blue': '#b0e0e6', 'Powder_Blue': '#b0e0e6',
    'Army_Green': '#225c36', 'Mint_Green': '#a2e4b8', 'Brown_3D': '#4b3621',
    'wash_green2': '#9c9986', 'peach2': '#d3c2af', 'Light_Grey': '#d3d3d3',
    'Rouge': '#a23b6c', 'Nude': '#f7d9bc', 'light_yellow': '#ffffc5',
    'Light_Yellow': '#ffffc5', 'Aqua_Green': '#00c0a3', 'Dark_Grey': '#63666a',
    'yellow_mustard': '#c6b629', 'Yellow_Mustard': '#c6b629',
    'Dark_pink': '#e75480', 'Dark_Pink': '#e75480', 'Dark_Brown': '#654321',
    'Blue_3d': '#1b3d81', 'Blue_3D': '#1b3d81', 'blue_black': '#112f4b',
    'Blue_Black': '#112f4b', 'Dark_Gold': '#966d33', 'Mustard': '#97663b',
    'Sky_Blue': '#b4d9ef', 'Mashroom': '#d8ccc0', 'Mushroom': '#d8ccc0',
    'Olive_Green': '#636b2f', 'Burgundy': '#660033', 'offwhite_black': '#faefea',
    'Ecru': '#ded4c8', 'Baby_Blue': '#89cff0', 'Neutral': '#edbfa7',
    'Silver_Grey': '#c0c0c0', 'Coral_Brown': '#9e4638', 'Lime': '#c7ea46',
    'Lime_Green': '#c7ea46', 'Yellow_Green': '#ccff00', 'Emerald_Green': '#00674f',
    'Dark_Orange': '#cc5500', 'Coral_Orange': '#ff7f50', 'Creamy_Coral': '#dd7788',
    'Orange': '#f5a454', 'Deep_Red': '#850101', 'Teal_Blue': '#01889f',
    'Fushia': '#a03972', 'Mustard_Yellow': '#ffce1b', 'Butter_Yellow': '#f5e8aa',
    'Butter_Cream': '#fff0ae', 'Teal': '#069494', 'Copper': '#b87333'
  };

  var colorCache = {};
  for (var key in hardcodedColors) {
    colorCache[key] = { bgColor: hardcodedColors[key] };
  }

  function buildCacheFromInlineStyles() {
    for (var i = 0; i < document.styleSheets.length; i++) {
      var sheet = document.styleSheets[i];
      if (sheet.href) continue;
      try {
        var rules = sheet.cssRules || sheet.rules;
        if (!rules) continue;
        for (var j = 0; j < rules.length; j++) {
          var rule = rules[j];
          if (!rule.selectorText) continue;
          var m = rule.selectorText.match(/\.wpb-variants-swatch\s+\.([\w_-]+)/);
          if (!m) continue;
          var colorKey = m[1];
          var bgColor = rule.style.backgroundColor || '';
          var bgImage = rule.style.backgroundImage || '';
          var bg = rule.style.background || '';
          if (bgImage && bgImage !== 'none') {
            colorCache[colorKey] = { bgImage: bgImage };
          } else if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
            colorCache[colorKey] = { bgColor: bgColor };
          } else if (bg && bg !== 'none' && bg !== '') {
            colorCache[colorKey] = { bg: bg };
          }
        }
      } catch (e) {}
    }
  }

  function applyColor(swatch) {
    if (swatch.dataset.mmColored) return;
    var colorName = swatch.getAttribute('data-swatch');
    if (!colorName) return;
    var keys = [
      colorName,
      colorName.replace(/ /g, '_'),
      colorName.replace(/_/g, ' ')
    ];
    var firstWord = colorName.split(' ')[0];
    if (firstWord !== colorName) keys.push(firstWord);
    var firstPart = colorName.split('_')[0];
    if (firstPart !== colorName) keys.push(firstPart);

    var data = null;
    for (var k = 0; k < keys.length; k++) {
      if (colorCache[keys[k]]) { data = colorCache[keys[k]]; break; }
    }
    if (!data) {
      var lower = colorName.toLowerCase();
      for (var ck in colorCache) {
        if (ck.toLowerCase() === lower ||
            ck.toLowerCase() === lower.replace(/ /g, '_') ||
            ck.toLowerCase() === lower.replace(/_/g, ' ')) {
          data = colorCache[ck]; break;
        }
      }
    }
    if (!data) return;
    if (data.bgImage && data.bgImage !== 'none') {
      swatch.style.backgroundImage = data.bgImage;
      swatch.style.backgroundSize = 'cover';
      swatch.style.backgroundPosition = 'center';
    } else if (data.bg && data.bg !== 'none' && data.bg !== '') {
      swatch.style.background = data.bg;
      swatch.style.backgroundSize = 'cover';
      swatch.style.backgroundPosition = 'center';
    } else if (data.bgColor && data.bgColor !== 'rgba(0, 0, 0, 0)' && data.bgColor !== 'transparent') {
      swatch.style.backgroundColor = data.bgColor;
    }
    swatch.dataset.mmColored = '1';
  }

  function applyAll() {
    document.querySelectorAll('.mm-swatch-item[data-swatch]').forEach(applyColor);
  }

  function init() {
    buildCacheFromInlineStyles();
    applyAll();

    // Watch for new swatches added via AJAX navigation
    var observer = new MutationObserver(function(mutations) {
      var found = false;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].nodeType === 1) { found = true; break; }
        }
        if (found) break;
      }
      if (found) applyAll();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Also listen for common theme AJAX events
    document.addEventListener('page:load', applyAll);
    document.addEventListener('shopify:section:load', applyAll);
    window.addEventListener('popstate', function() {
      setTimeout(applyAll, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
